import {defineMessages} from 'react-intl';

export default defineMessages({
	title: {
		id: 'popups.notifyMe.title',
		defaultMessage: 'Request your size'
	},
	description: {
		id: 'popups.notifyMe.description',
		defaultMessage: 'Give us your email if you\'d like us to let you know when item is available.'
	},
	generalError: {
		id: 'common.error.general',
		defaultMessage: 'Oops! Something went wrong.'
	},
	notifyMeSuccess: {
		id: 'popups.notifyMe.success',
		defaultMessage: 'Thanks, your request has been saved.'
	},
	submitBtnText: {
		id: 'popups.notifyMe.submitBtnText',
		defaultMessage: 'Send me a notification'
	},
	privacyPolicyText: {
		id: 'popups.notifyMe.privacyPolicyText',
		defaultMessage: 'By submitting you accept our <cta>Privacy Policy</cta>'
	},
	size: {
		id: 'productDetail.sizeSelectorSelected',
		defaultMessage: 'Size'
	},
	color: {
		id: 'productDetail.colorSelectorSelected',
		defaultMessage: 'Color'
	},
});
